import en from './en.json'
import zh_cn from './zh-cn.json'
import zh_hk from './zh-hk.json'

import en2 from './en2.json'
import zh_cn2 from './zh-cn2.json'
import zh_hk2 from './zh-hk2.json'

export const defaultLocale = 'en'

export const languages = {
  en: {...en, ...en2},
  "zh-cn": {...zh_cn, ...zh_cn2},
  "zh-hk": {...zh_hk, ...zh_hk2},  
}